import styled, { css } from 'styled-components'

type ItemProps = {
  active: boolean
}

export const Item = styled.button<ItemProps>`
  border: 1px solid #C1C1C1;
  color: #1B1B1B;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 64px;
  height: 35px;
  background-color: #fff;

  &:hover {
    background-color: #F5F5F5;
  }

  ${(props) => props.active && 
    css`
      border: none;
      color: #fff;
      background-color: #1F35B5;

      &:hover {
        background-color: #1F35B5;
      }
    `}

  &:disabled{
    color: #C1C1C1;
    border: 1px solid #C1C1C1;
    cursor: not-allowed;
    text-decoration: line-through;
    text-decoration-thickness: 2px; 

    &:hover {
      background-color: #fff;
    }
  }
`